<template>
	<div class="open-account-bank">
		
		<h1 class="h1_title">{{translate('hkbank_card_information')}}</h1>
		
		<van-form @submit="nextStep()" :label-width="100">

			<h4 class="h4_title">{{translate('overseas_bank_account_info')}}</h4>

			<van-field 
				v-model="formItem.country" 
				:label="translate('nation')" 
				:placeholder="translate('please_enter')"
				:rules="rules.country"
				required
			/>
			
			<van-field 
				v-model="formItem.bank" 
				:label="translate('hkbank_bank')" 
				:placeholder="translate('please_enter')"
				:rules="rules.bank"
				required
			/>

			<van-field 
				v-model="formItem.bank_address" 
				:label="translate('hkbank_address')" 
				:placeholder="translate('please_enter')"
				:rules="rules.bank_address"
				required
			/>
			<van-field 
				v-model="formItem.account_name" 
				:label="translate('account_name')" 
				:placeholder="translate('please_enter')"
				:rules="rules.account_name"
				required
			/>
			<van-field 
				v-model="formItem.account_no" 
				:label="translate('hkbank_card_number')" 
				:placeholder="translate('please_enter')"
				:rules="rules.account_no"
				required
			/>
			<van-field
				v-model="formItem.account_address" 
				:label="translate('hkbank_account_address')" 
				:placeholder="translate('please_enter')"
				:rules="rules.account_address"
				required
			/>

			<van-field
				v-model="formItem.swift_code"
				label="SWIFT CODE"
				:placeholder="translate('please_enter')"
				:rules="rules.swift_code"
				required
			/>
			
			<div class="common_block">
				<van-button type="warning" block round native-type="submit">{{translate('hkbank_submit')}}</van-button>
			</div>
		</van-form>
	
	</div>
</template>

<script>
	export default {
		name: 'account_hkbank',
		data() {
			return {
				formItem: {
					country: "",
					bank: "",
					bank_address: "",
					account_name: "",
					account_no: "",
					account_address: "",
					swift_code: "",
				},

				rules: {
					country: [
						{
							required: true,
							message: this.translate('please_fill_in_the_country'),
							trigger: 'onBlur'
						}
					],
					bank: [
						{
							required: true,
							message: this.translate('please_fill_in_the_bank'),
							trigger: 'onBlur'
						}
					],
					bank_address: [
						{
							required: true,
							message: this.translate('please_fill_in_the_bank_address'),
							trigger: 'onBlur'
						}
					],
					account_name: [
						{
							required: true,
							message: this.translate('please_fill_in_the_account_name'),
							trigger: 'onBlur'
						}
					],
					account_no: [
						{
							required: true,
							message: this.translate('please_fill_in_the_bank_number'),
							trigger: 'onBlur'
						}
					],
					account_address: [
						{
							required: true,
							message: this.translate('please_fill_account_address'),
							trigger: 'onBlur'
						}
					],
					swift_code: [
						{
							required: true,
							message: this.translate('please_fill_in_the_swift_code'),
							trigger: 'onBlur'
						}
					],
				},

				token: "",
				
				resourceURL: this.$axios.defaults.resourceURL,
				
				disabledSubmit: true,
				
			}
		},
		mounted() {
			
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.token = this.$route.query.token
				
				this.init()
			}
		},
		methods: {
			init(){
				
				this.$axios({
					method: 'post',
					url: 'account_open/info',
					data: {
						token: this.token
					}
				}).then ((res) => {
					if (res.success) {

						if (res.data.status == 2) {
							//	待审核
							this.$router.replace('/account/success')
						} else if (res.data.status == 3) {
							//	不通过
							this.$router.replace('/account/fail?token=' + this.token)
						} else {
							
							var abroad_data = res.data.abroad_data		
							
							if (abroad_data.length != 0) {
								this.formItem.country = abroad_data.country ? abroad_data.country : ""
								this.formItem.bank = abroad_data.bank ? abroad_data.bank : ""
								this.formItem.bank_address = abroad_data.bank_address ? abroad_data.bank_address : ""
								this.formItem.account_name = abroad_data.account_name ? abroad_data.account_name : ""
								this.formItem.account_no = abroad_data.account_no ? abroad_data.account_no : ""
								this.formItem.account_address = abroad_data.account_address ? abroad_data.account_address : ""
								this.formItem.swift_code = abroad_data.swift_code ? abroad_data.swift_code : ""
								
							}

						}

						
					}else{
						this.$toast.fail(res.error_text)
					}
				})

				
			},

			nextStep(){

				this.$axios({
					method: 'post',
					url: 'account_open/update',
					data: {
						token: this.token,
						abroad_data: JSON.stringify(this.formItem)
					}
				}).then ((res) => {
					if (res.success) {
						// this.$router.push('/account/success')
						this.$router.push('/account/career?token=' + this.token)
					}else{
						this.$toast.fail(res.error_text)
					}
				})
				
			}
		},
	}
</script>